<div class="liat-activation-container">
    <div class="liat-activation-form-card">
        <ng-container *transloco="let t; read: 'liatActivation'">
            <owc-backdrop *ngIf="isLoading" class="loading-overlay" disableScrollLock>
                <owc-progress-spinner size="large"></owc-progress-spinner>
            </owc-backdrop>
        
            <owc-card dragging elevated rounded class="card">
                <owc-component-header slot="header">
                    <h2 class="card-header">{{ t('header') }}</h2>
                </owc-component-header>
        
                <div class="liat-activation-content">
                    <form [formGroup]="liatActivationForm" (ngSubmit)="submitLiatActivationForm()">
                        <div class="margin-top-25">
                            <owc-assistive-text class="text-medium-weight">
                                {{ t('field1Label') }}
                            </owc-assistive-text>
                            <owc-radio-group [value]="liatActivationForm.get('activationType')?.value" (valueChange)="onRadioChange($event)">
                                <owc-radio value="Software Activation">{{ t('field1Option1') }}</owc-radio>
                                <owc-radio value="Assay script Activation">{{ t('field1Option2') }}</owc-radio>
                            </owc-radio-group>
                        </div>
        
                        <div class="margin-top">
                            <owc-assistive-text class="text-medium-weight">
                                {{ t('field2Label1') }}
                            </owc-assistive-text>
                            <br>
                            <owc-assistive-text class="white-space-normal text-size">
                                {{ t('field2Label2') }}
                            </owc-assistive-text>
                            <owc-input class="margin-top" [value]="liatActivationForm.get('registrationKeys')?.value" type="textarea"
                                [name]="'Registration Key'" [rows]="rows" (blur)="formatRegistrationKeys()"
                                (valueChange)="onInputChange($event)"
                                [placeholder]="translocoService.translate('liatActivation.registrationKeyPlaceholder')"
                                [cols]="cols">
                                <owc-assistive-text class="white-space-normal assistive-text" trigger="input, blur">
                                    {{ t('field2AssistiveText1') }}
                                </owc-assistive-text>
                            </owc-input>
        
                            <owc-assistive-text *ngIf="(liatActivationForm.controls['registrationKeys'].dirty ||
                                                    liatActivationForm.controls['registrationKeys'].touched)">
                                <span *ngIf="liatActivationForm.controls['registrationKeys'].errors?.['required']"
                                    class="text-error">
                                    {{ t('field2AssistiveText2') }}
                                </span>
                                <span *ngIf="liatActivationForm.controls['registrationKeys'].errors?.['invalidRegKeys']"
                                    class="text-error">
                                    {{ t('field2AssistiveText3') }}
                                </span>
                            </owc-assistive-text>
                        </div>
        
                        <div class="margin-top">
                            <owc-assistive-text class="white-space-normal text-size">
                                {{ t('field3Label') }}
                            </owc-assistive-text>
                            <owc-input class="margin-top"
                                [placeholder]="translocoService.translate('liatActivation.emailPlaceHolder')" [cols]=cols
                                [rows]="1" auto-focus controlled (valueChange)="onEmailChange($event)" resizable rounded
                                type="textarea" [value]="liatActivationForm.get('email')?.value">
                            </owc-input>
                        </div>
        
                        <div class="margin-top, checkbox-container">
                            <owc-checkbox [value]="liatActivationForm.get('termsAndConditions')?.value" disable-ripple
                                (valueChange)="onTermsChange($event)">
                            </owc-checkbox>
                            <p>
                                <span>{{ t('field4Text1') }} </span>
                                <a class="text-primary" href="https://www.roche.com/legal-statement" target="_blank">
                                    {{t('field4Text2') }}</a>
                                <span> {{ t('field4Text3') }} </span>
                                <a class="text-primary" href="https://www.roche.com/privacy-policy" target="_blank">
                                    {{t('field4Text4') }}</a>
                                <span> {{ t('field4Text5') }}</span>
                            </p>
                        </div>
        
        
                        <div class="action-buttons">
                            <owc-button class="button" elevated size="medium" type="reset" variant="secondary">
                                {{ t('clearButton') }}
                            </owc-button>
                            <owc-button class="button" [disabled]="liatActivationForm.invalid" elevated size="medium"
                                type="submit" variant="primary">
                                {{ t('submitButton') }}
                            </owc-button>
                        </div>
                    </form>
                </div>
            </owc-card>
        </ng-container>
    </div>
</div>